import { Component, OnInit } from '@angular/core';

import { UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: [],
  standalone: false,
})
export class SelectComponent implements OnInit {
  field: Fields;
  group: UntypedFormGroup;
  modeSelect;
  constructor(private http: HttpClient) {}
  ngOnInit() {
    if (this.field && this.field.url) {
      this.http.get<any>(this.field.url).subscribe((_data) => {
        //   if(this.field.name=="interviewLocation"){
        //     for(let i in data){
        //       let opt:any = {
        //        key:data[i].cityName,
        //        value:data[i].cityName,
        //        selected:false
        //      }
        //      this.field.options.push(opt);
        //     }
        //   }else if(this.field.name=="currentEmployer"){
        //    for(let i in data){
        //      let opt:any = {
        //       key:data[i].organizationName,
        //       value:data[i].organizationName,
        //       selected:false
        //     }
        //     this.field.options.push(opt);
        //    }
        //    console.log(this.field.options);
        //   }
      });
    }
    if (this.field.options && this.field.options.length !== 0) {
      this.field.options.forEach((element) => {
        if (element.selected === true) {
          // console.log(this.field.name);
          this.modeSelect = element.key;
          // console.log("this.modeSelect--"+this.modeSelect)
          this.group.get(this.field.name).setValue(element.value);
        }
      });
    }
  }

  onchange(event) {
    // console.log("event----", event)
    this.setValidationDetails(event);
  }

  setValidation() {
    if (this.field.name == 'hiringType') {
      const event = this.group.get('hiringType').value;
      if (event === 'Regular') {
        // console.log(this.group.get('digitalOffering'));
        this.group.get('digitalOffering').clearValidators();
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').clearValidators();
        this.group.get('digitalTag').updateValueAndValidity();
      } else {
        this.group.get('digitalOffering').setValidators(Validators.required);
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').setValidators(Validators.required);
        this.group.get('digitalTag').updateValueAndValidity();
      }
      // console.log("data---" + this.group);
    }
  }

  setValidationDetails(event) {
    if (this.field.name == 'hiringType') {
      event = this.group.get('hiringType').value;
      if (event === 3) {
        // console.log(this.group.get('digitalOffering'));
        this.group.get('digitalOffering').clearValidators();
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalOffering').setValue('');
        this.group.get('digitalTag').clearValidators();
        this.group.get('digitalTag').updateValueAndValidity();
        this.group.get('digitalTag').setValue('');
      } else {
        this.group.get('digitalOffering').setValue('');
        this.group.get('digitalOffering').setValidators(Validators.required);
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').setValue('');
        this.group.get('digitalTag').setValidators(Validators.required);
        this.group.get('digitalTag').updateValueAndValidity();
      }
      // console.log("data---" + this.group);
    }
  }
}
